import React from "react";


interface BtmButtonProps {
    disabled: boolean;
    onClick: () => void;
    label: string;
}

const BtmButton = ({disabled = true, onClick =  () => {}, label = "Konfirmasi"}: BtmButtonProps) => {
    return (
        // sticky
        <nav className="bottom-0 z-51 bg-white px-4 py-3 flex items-center">
            <button
                disabled={disabled}
                onClick={onClick}
                className={`w-full ${
                    disabled
                        ? "bg-gray-200 text-gray-400"
                        : "bg-red-500 text-white"
                } text-sm py-3 rounded-full `}
            >
                {label}
            </button>
        </nav>
    );
}

export default BtmButton;